let htmlwidth = document.documentElement.clientWidth || document.body.clientWidth;
let htmlDom = document.getElementsByTagName('html')[0];
let fontSize = Math.min(htmlwidth, 820) / 10;
htmlDom.style.fontSize = fontSize + 'PX';